import { Injectable } from '@angular/core';
import { AnalyticsContext } from './analytics-context';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsNavigation {
  constructor(private analyticsContext: AnalyticsContext) {}

  async getNavigationParams(url?) {
    const {
      mandatoryFields,
      optionalFields
    } = await this.analyticsContext.getFields(url);
    const params = {
      category: 'navigation',
      action: 'navigation',
      ...mandatoryFields,
      ...optionalFields
    };
    return Promise.resolve(params);
  }
}
